import { differenceInCalendarDays, format, parseISO } from 'date-fns'
import { id } from 'date-fns/locale'

export const FORMAT_DATE_DEFAULT = 'd MMMM yyyy'
export const FORMAT_DATE_DATEPICKER = 'yyyy-MM-dd'

export const WIB_TIME_ZONE = 'Asia/Jakarta'

// Fixed to Asia/Jakarta so output is identical on server (SSR) and client,
// regardless of the runtime/device timezone.
const wibDateTimeFormatter = new Intl.DateTimeFormat('id-ID', {
  timeZone: WIB_TIME_ZONE,
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
})

export const formatDate = (
  date: Date | string | number,
  dateFormat = FORMAT_DATE_DEFAULT
) => {
  try {
    return format(new Date(date), dateFormat, {
      locale: id,
    })
  } catch {
    return date
  }
}

export const formatDateTimeWIB = (date: Date | string | number) => {
  const parsedDate = new Date(date)

  if (Number.isNaN(parsedDate.getTime())) return String(date)

  const parts = wibDateTimeFormatter.formatToParts(parsedDate)
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find(({ type: partType }) => partType === type)?.value ?? ''

  return `${part('day')} ${part('month')} ${part('year')}, ${part('hour')}:${part(
    'minute'
  )} WIB`
}

export function countDaysInclusive(startDate?: string, endDate?: string) {
  if (!startDate || !endDate) return 0
  const start = parseISO(startDate)
  const end = parseISO(endDate)
  return differenceInCalendarDays(end, start) + 1
}
